import React, { Component } from "react";
import {
  config,
  SERVICE_API,
  VIEW_NAME,
  DISPATCH_ID,
  ROLES,
} from "../libs/utils/Const";
import { connect } from "react-redux";
import {
  ItemDetailsModal,
  Pagination,
  Paginations,
  SideBarItems,
} from "./index";
import CurrencyFormat from "react-currency-format";
import "./ItemSlider.css";
import { animateScroll as scroll, scroller } from "react-scroll";
import moment from "moment";

class ItemsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: null,
      card: true,
      list: false,
    };
    //this.addCartHover = React.createRef();
    this.mouseOverAddCart = this.mouseOverAddCart.bind(this);
    this.mouseOutAddCart = this.mouseOutAddCart.bind(this);
    this.scrollToBottom = this.scrollToBottom.bind(this);
    this.iconMouse = [];
    this.iconMouseOver = [];
  }

  componentDidMount = () => {
    this.scrollToBottom();
  };

  scrollToBottom() {
    scroll.scrollToTop({
      duration: 1500,
      delay: 100,
      smooth: "easeOutQuart",
      isDynamic: true,
    });
  }

  changeQuantity = (index, item, event) => {
    const {
      changeQuantity,
      notificationReducer: { showAlert },
      itemsReducer: { items: itemsSearch },
    } = this.props;

    let newQuantity;
    itemsSearch.map((itemFilter) => {
      if (itemFilter.ItemCode === item.ItemCode) {
        newQuantity = itemFilter.quantity || "1";
      }
    });

    let onHand = (item.OnHandPrincipal - item.IsCommited);
    if (Number(newQuantity) > Number(onHand)) {
      if (Number(onHand) === 0) {
        showAlert({
          type: "warning",
          message:
            "Se excede el número de articulos disponibles de este producto",
          timeOut: 2500,
        });
      }
      newQuantity = onHand;
    }

    // color azul rinti
    // document.getElementById(item.ItemCode).style.backgroundColor = "#005DA8";
    // document.getElementById(item.ItemCode).style.borderColor = "#005DA8";

    if (Number(newQuantity) < 1) {
      changeQuantity(index, item, newQuantity, false); //delete
    } else {
      changeQuantity(index, item, newQuantity, true); // add
    }
  };

  // setSepecialPrice = (itemParameter) =>{
  //     let item = itemParameter;
  //     const {itemsReducer: {specialPrice}} = this.props;

  //     let CardCode = specialPrice.CardCode;
  //     let PriceList = specialPrice.ListNum && specialPrice.ListNum !== '' ? specialPrice.ListNum : specialPrice.priceList;

  //     // Special Prices Validation
  //     //########################################################################################################################
  //     let priority2 = "*" + PriceList;
  //     let formattedDocDate = moment().format('YYYY/MM/DD');

  //     let flagSN = true; // Socio de negocio
  //     let flagPriceList = true; // Lista de precios
  //     let flagPricePriority = true;
  //     let maxQuantity = 0; // Cantidad maxima a alegir
  //     let priceItem = -1;
  //     let discount = -1;
  //     let priceBeforeDisc= -1;

  //     item.QuantitySpecial = item.quantity;
  //     item.PriceTest = -1;

  //     // Socio de negocios
  //     if(specialPrice.specialPrices.length > 0){
  //         specialPrice.specialPrices.map((itemPrice) => {
  //             if (item.ItemCode == itemPrice.ItemCode && itemPrice.CardCode == CardCode) {
  //                 if (itemPrice.children.length > 0) {
  //                     itemPrice.children.map((child) => {
  //                         let inicial = new Date(child.FromDate);
  //                         let final = new Date(child.ToDate || formattedDocDate);
  //                         let docDate = new Date(formattedDocDate);

  //                         inicial.setMinutes(inicial.getMinutes() + inicial.getTimezoneOffset());
  //                         final.setMinutes(final.getMinutes() + final.getTimezoneOffset());

  //                         inicial.setHours(0, 0, 0, 0);
  //                         final.setHours(0, 0, 0, 0);
  //                         docDate.setHours(0, 0, 0, 0);

  //                         if (docDate >= inicial && docDate <= final) {
  //                             if (itemPrice.childrenCantidades.length > 0) {
  //                                 // Cantidades
  //                                 itemPrice.childrenCantidades.map((child2) => {
  //                                     let inicialCantidad = new Date(child2.FromDate);
  //                                     let finalCantidad = new Date(child2.ToDate || formattedDocDate);

  //                                     if(docDate >= inicialCantidad && docDate <= finalCantidad){
  //                                         if ((item.QuantitySpecial || 1) >= child2.Amount) {
  //                                             if(child2.Amount > maxQuantity) {
  //                                                 maxQuantity = child2.Amount;
  //                                                 item.DiscountPercentSpecial = child2.Discount;
  //                                                 flagPricePriority = false;
  //                                                 priceItem = parseFloat(child2.Price);
  //                                                 discount = parseFloat(child2.Discount);
  //                                                 priceBeforeDisc = ((100 * priceItem) / (100 - discount)).toFixed(2);
  //                                             }
  //                                         }
  //                                     }
  //                                 });
  //                                 if(maxQuantity != 0){
  //                                     flagSN = false;
  //                                 }
  //                                 if(flagSN){
  //                                     // Fechas
  //                                     item.DiscountPercentSpecial = child.Discount;
  //                                     flagPricePriority = false;
  //                                     priceItem = parseFloat(child.Price);
  //                                     discount = parseFloat(child.Discount);
  //                                     priceBeforeDisc = ((100 * priceItem) / (100 - discount)).toFixed(2);
  //                                     flagSN = false;
  //                                 }
  //                             } else {
  //                                 // Fechas
  //                                 item.DiscountPercentSpecial = child.Discount;
  //                                 flagPricePriority = false;
  //                                 priceItem = parseFloat(child.Price);
  //                                 discount = parseFloat(child.Discount);
  //                                 priceBeforeDisc = ((100 * priceItem) / (100 - discount)).toFixed(2);
  //                                 flagSN = false;
  //                             }
  //                         } else {
  //                             // General
  //                             if(flagSN){
  //                                 item.DiscountPercentSpecial = itemPrice.Discount;
  //                                 flagPricePriority = false;
  //                                 priceItem = parseFloat(itemPrice.Price);
  //                                 discount = parseFloat(itemPrice.Discount);
  //                                 priceBeforeDisc = ((100 * priceItem) / (100 - discount)).toFixed(2);
  //                             }
  //                         }
  //                     })
  //                 } else {
  //                     //General
  //                     item.DiscountPercentSpecial = itemPrice.Discount;
  //                     flagPricePriority = false;
  //                     priceItem = parseFloat(itemPrice.Price);
  //                     discount = parseFloat(itemPrice.Discount);
  //                     priceBeforeDisc = ((100 * priceItem) / (100 - discount)).toFixed(2);
  //                 }
  //             }
  //         });
  //     }
  //     // Lista de inventario
  //     if(specialPrice.specialPricesList.length > 0 && flagPricePriority){
  //         specialPrice.specialPricesList.map((itemPrice2)  => {
  //             if(itemPrice2.ItemCode == item.ItemCode && itemPrice2.CardCode == priority2){
  //                 if (itemPrice2.children.length > 0) {
  //                     itemPrice2.children.map((child)=> {

  //                         let inicial = new Date(child.FromDate);
  //                         let final = new Date(child.ToDate || formattedDocDate);
  //                         let docDate = new Date(formattedDocDate);

  //                         inicial.setMinutes(inicial.getMinutes() + inicial.getTimezoneOffset());
  //                         final.setMinutes(final.getMinutes() + final.getTimezoneOffset());

  //                         inicial.setHours(0, 0, 0, 0);
  //                         final.setHours(0, 0, 0, 0);
  //                         docDate.setHours(0, 0, 0, 0);
  //                         if (docDate >= inicial && docDate <= final) {
  //                             if (itemPrice2.childrenCantidades.length > 0) {
  //                                 // Cantidades
  //                                 itemPrice2.childrenCantidades.map((child2) => {
  //                                     let inicialCantidad = new Date(child2.FromDate);
  //                                     let finalCantidad = new Date(child2.ToDate || formattedDocDate);

  //                                     if(docDate >= inicialCantidad && docDate <= finalCantidad){
  //                                         if ((item.QuantitySpecial || 1) >= child2.Amount) {
  //                                             if(child2.Amount > maxQuantity) {
  //                                                 maxQuantity = child2.Amount;
  //                                                 item.DiscountPercentSpecial = child2.Discount;
  //                                                 flagPricePriority = false;
  //                                                 priceItem = parseFloat(child2.Price);
  //                                                 discount = parseFloat(child2.Discount);
  //                                                 priceBeforeDisc = ((100 * priceItem) / (100 - discount)).toFixed(2);
  //                                             }
  //                                         }
  //                                     }
  //                                 });
  //                                 if(maxQuantity != 0){
  //                                     flagPriceList = false;
  //                                 }
  //                                 if(flagPriceList){
  //                                     // Fechas
  //                                     item.DiscountPercentSpecial = child.Discount;
  //                                     flagPricePriority = false;
  //                                     priceItem = parseFloat(child.Price);
  //                                     discount = parseFloat(child.Discount);
  //                                     priceBeforeDisc = ((100 * priceItem) / (100 - discount)).toFixed(2);
  //                                     flagPriceList = false;
  //                                 }
  //                             } else {
  //                                 // Fechas
  //                                 item.DiscountPercentSpecial = child.Discount;
  //                                 flagPricePriority = false;
  //                                 priceItem = parseFloat(child.Price);
  //                                 discount = parseFloat(child.Discount);
  //                                 priceBeforeDisc = ((100 * priceItem) / (100 - discount)).toFixed(2);
  //                                 flagPriceList = false;
  //                             }
  //                         } else {
  //                             // General
  //                             if(flagPriceList){
  //                                 item.DiscountPercentSpecial = itemPrice2.Discount;
  //                                 flagPricePriority = false;
  //                                 priceItem = parseFloat(itemPrice2.Price);
  //                                 discount = parseFloat(itemPrice2.Discount);
  //                                 priceBeforeDisc = ((100 * priceItem) / (100 - discount)).toFixed(2);
  //                             }
  //                         }
  //                     })
  //                 } else {
  //                     // General
  //                     item.DiscountPercentSpecial = itemPrice2.Discount;
  //                     flagPricePriority = false;
  //                     priceItem = parseFloat(itemPrice2.Price);
  //                     discount = parseFloat(itemPrice2.Discount);
  //                     priceBeforeDisc = ((100 * priceItem) / (100 - discount)).toFixed(2);
  //                 }
  //             }
  //         });
  //     }
  //     //No tiene precio especial
  //     if(flagPricePriority){
  //         item.DiscountPercentSpecial = 0;
  //     }

  //     // Precios por descuentos especiales
  //     if(priceBeforeDisc != -1){
  //         item.Price = Number(priceItem);
  //         item.PriceTest = Number(priceItem);
  //         item.PriceBeforeDiscount = Number(priceBeforeDisc);
  //     }

  //     let price = item.PriceTest !== -1 ? Number(item.Price).toFixed(2) : -1;
  //     return price;
  // }

  changLocalQuantity = (index, item, event, um)=>{
    const {shoppingCartReducer: {items},itemsReducer: {items: itemsSearch}} = this.props;
    let newQuantity =  event.nativeEvent.target.value;

    // color success
    // document.getElementById(item.ItemCode).style.backgroundColor = "#28a745"; 
    // document.getElementById(item.ItemCode).style.borderColor = "#28a745";     
    if (newQuantity && um === "KG") {
        
        itemsSearch.map( itemFilter => {
            if (itemFilter.ItemCode === item.ItemCode && parseInt(item.OnHandPrincipal - item.IsCommited) >= newQuantity) {
                itemFilter.quantity = newQuantity;
            }
        });
        this.applyFilters(itemsSearch);
    }if(newQuantity % 1 === 0 && um !== "KG"){
        
        itemsSearch.map( itemFilter => {
            if (itemFilter.ItemCode === item.ItemCode && parseInt(item.OnHandPrincipal - item.IsCommited) >= newQuantity) {
                itemFilter.quantity = newQuantity;
            }
        });
        this.applyFilters(itemsSearch);
    } else {
        return;
    } 
}

  applyFilters = (data) => {
    const { setItemsFilterSearch } = this.props;
    // enableSpinner(true);
    setItemsFilterSearch(data);
    // enableSpinner(false);

    // $("#menuCategories").removeClass('open-menu-categories');
  };

  searchPage = async (page = 0) => {
    const {
      setNextPage,
      itemsReducer: {
        searchByCategories,
        searchByKey,
        category,
        idCategory,
        location,
        searchByDash,
      },
      items,
    } = this.props;
    page = page === 1 ? 0 : (page - 1) * 50;
    
    if (location === "menuCategories") {
      setNextPage(page);
      await searchByCategories(idCategory, page);
    } else if (location === "navBar") {
      await searchByKey(page);
    } else if (location === "redView") {
      await searchByKey(page, "redView");
    } else if (location === "whiteView") {
      await searchByKey(page, "whiteView");
    } else if (location === "outletView") {
      await searchByKey(page, "outletView");
    } else if (location === "promocion") {
      await searchByKey(page, "promocion");
    } else if (location === "masvendidos") {
      await searchByKey(page, "masvendidos");
    } else if (location === "nuevosproductos") {
      await searchByKey(page, "nuevosproductos");
    } else if (location === "remates") {
      await searchByKey(page, "remates");
    } else if (location === "vitrinaView") {
      await searchByKey(page, "vitrinaView");
    }
  };

  // onPageChanged = async data => {
  //     const {itemsReducer} = this.props;
  //     const { currentPage,nextPage, totalPages} = data;
  //     await itemsReducer.searchByKey(nextPage);
  //     this.setState({ currentPage, totalPages });
  // }

  mouseOverAddCart = (index, flag, event) => {
    if (this.iconMouse && this.iconMouse.length > 0) {
      this.iconMouse[index].style.display = "none";
      this.iconMouseOver[index].style.display = "block";
    }
  };

  mouseOutAddCart = (index, flag, event) => {
    if (flag == "green") {
      event.currentTarget.style.backgroundColor = "#232323";
      event.currentTarget.className = "btn btn-block botonAgregar";
    } else if (flag == "yellow") {
      event.currentTarget.style.backgroundColor = "#232323";
      event.currentTarget.className = "btn btn-block botonAgregar";
    } else {
      event.currentTarget.style.backgroundColor = "#e27753";
      event.currentTarget.className = "btn btn-block botonAgregarAgotado";
    }
    // Íconos
    if (this.iconMouse && this.iconMouse.length > 0) {
      this.iconMouse[index].style.display = "block";
      this.iconMouseOver[index].style.display = "none";
    }
  };

  changeFilter = (type) => {
    this.setState({
      card: type === "card" ? true : false,
      list: type === "list" ? true : false,
    });
  };
  /*Funcionalidad del boton de las caracteristicas*/
  barraSide = () => {
    const linkFiltro = document.querySelectorAll(".linkFilter");
    const btnToggle = document.querySelector(".toggle-btn");

    btnToggle.addEventListener(
      "click",
      (function () {
        document.getElementById("sidebar").classList.toggle("active");
        document.querySelector(".toggle-btn").classList.toggle("active");
      })()
    );

    linkFiltro.forEach((el) =>
      el.addEventListener("click", function () {
        document.getElementById("sidebar").classList.remove("active");
        document.querySelector(".toggle-btn").classList.remove("active");
      })
    );
  };

  render() {
    const {
      items,
      type,
      changeBackOrder,
      updateFavorite,
      deleteShoppingCart,
      openDetails,
      itemsReducer: { location, TotalPage, itemsCategories },
      viewOne,
      configReducer: { currency },
      sessionReducer: { role },
    } = this.props;
    const { currentPage, card, list } = this.state;

    return (
      <div id="scrollDownPlease">
      <div className="row justify-content-center">
        <div className="col-md-10" style={{marginLeft:"45px"}}>
        <div className="row justify-content-end">
              <div className="col-md-auto bg-white p-2 justify-content-center text-center mr-md-2 mb-2" style={{marginTop:'15px'}}>
                <i
                  onClick={() => {
                    this.changeFilter("card");
                  }}
                  className={"fas fa-th-large mr-3"}
                  style={{
                    color: card === true ? "black" : "grey",
                    cursor: "pointer",
                  }}
                />
                <i
                  onClick={() => {
                    this.changeFilter("list");
                  }}
                  className={"fas fa-th-list mr-3"}
                  style={{
                    color: list === true ? "black" : "grey",
                    cursor: "pointer",
                  }}
                />
                <span className="font-weight-bold">
                  {" "}
                  {TotalPage} Productos{" "}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div
          className="container-fluid row"
          style={{
            margin: 0,
            display: "flex",
            justifyContent: "center",
            fontFamily: "Montserrat",
          }}
        >
          {(!type || type !== "RedCompensasView") && (
            /* Lista categorias */
            <div className="col-md-3 colmd" style={{height:"auto", marginBottom:"-2.5rem", top:"3rem"}}>
              <div
                className="toggle-btn"
                onClick={() => {
                  this.barraSide();
                }}
              >
                <span className="fa fa-filter"> Filtros</span>
              </div>

              <div id="sidebar" style={{ OverflowY: "scroll", marginTop: "28px" }}>
                <div style={{ padding: "1rem 1rem 1rem 1rem" }}>
                  <SideBarItems
                    totalRows={TotalPage}
                    dataCategories={itemsCategories}
                    viewOne={viewOne ? viewOne : ""}
                  />
                </div>
              </div>
            </div>
          )}
          <div
            className={
              !type || type !== "RedCompensasView"
              ? "col-md-9 colmdd" 
              : "col-md-12"
              } 
              style={{marginTop:'4rem'}}
              >
            <div className='row'>
            {/* <ItemDetailsModal view={VIEW_NAME.ITEMS_VIEW}/> */}
            {items &&
              items.map((item, index) => {
                item.ItemName = item.ItemName || "";                
                // Use state to change la manera en la que se ve
                
                return (
                  <div 
                  id="CardItem" 
                  style={{margin: card ? 12 : "15px 15px",
                  position: card ? "" : "", 
                  height: "auto", 
                  flexDirection: card ? "" : "column !important", 
                  width: card ? "" : "55rem",
                }}
                  key={item.ItemCode + item.ItemName + item.Price}
                  >
                    <div 
                    style={{ 
                      display: "flex",
                      justifyContent: "center", 
                      alignItems: "center",
                      }}
                      >
                      <div
                      className={`card ${card ? "imageCard" : "list-card-container"}`} 
                      style={{ 
                        aspectRatio: card ? "1/1" : "",
                        width: card ? "279.41px" : "100%",
                        height: card ? "390px" : "100%",
                        borderRadius: card ? "10px" : "10px",
                        maxWidth: card ? "100%" : "100%", 
                        display: "flex",
                        flexWrap: "nowrap",
                        padding: card ? "" : "0.8rem",
                        }}
                        >
                        <div className='row'>
                        <div
                        style={{
                          display:
                            !item.U_FMB_Handel_Promo ||
                            item.U_FMB_Handel_Promo === "" ||
                            item.U_FMB_Handel_Promo == 0
                              ? "none"
                              : "table",
                        }}
                      >
                            <div
                              className="p-3"
                            style={{ position: "absolute" 
                            }}
                            onClick={() => openDetails(item)}
                            >
                              <span style={{ backgroundColor: "#BE1824", padding: "8px", borderRadius: "10px",  marginTop: "8px" }}>
                            <blink> OFERTA </blink>
                          </span>
                            </div>
                          </div>
                          <div 
                          onClick={() => openDetails(item)}
                          >
                            <img
                              className={card === true ? "card-img-top" : "card-img-top list-card-image"}
                              style={{
                                height: card === true ? "13rem" : "100px",
                                width: card === true ? "13rem" : "100px", // Ajusta el ancho deseado para el modo lista
                                backgroundColor: "transparent",
                                borderTopRightRadius: "10px",
                                cursor: "pointer",
                                margin: "auto",
                                objectFit: "cover",
                              }}
                              onError={(e) => { e.target.src = require("../images/noImage.png");}}
                              src={
                          item.PicturName
                            ? config.BASE_URL +
                              SERVICE_API.getImage +
                              "/" +
                              item.PicturName
                            : require("../images/noImage.png")
                        }
                        alt=" "
                      />
                          </div>
                          <div
                        className={
                          card === true
                            ? "col-12  mt-1"
                            : "col-8 detailsItemList  mt-1"
                        }
                      >
                            <div
                            className="card-body"
                            style={{ 
                              height: "fit-content", 
                              margin: 0, 
                              padding: "2px",
                              minHeight: card === true ? "140px" : "auto",
                              color: config.itemsList.textColor,
                              }}
                              >
                              <div>
                            <div className="overflow-auto">
                              <p
                                className="card-title text-left ItemName"
                                style={{
                                  fontWeight: "bold",
                                  padding: 1,
                                  fontSize: 16,
                                  color: config.itemsList.textPrice2,
                                }}
                              >
                                {/*item.ItemName.length > 43 ? item.ItemName.substring(0, 42 ) + "..." : item.ItemName*/}
                                {item.ItemName
                                  ? item.ItemName.length > 44
                                    ? item.ItemName.substring(0, 43) + " ... "
                                    : item.ItemName
                                  : " "}
                              </p>
                            </div>
                            
                            {item && item.SalUnitMsr ? 
                            <div className="overflow-auto">
                                <p 
                                className="text-left ItemSalUnitMsr"
                                style={{                               
                                  padding: 1,
                                  fontSize: "1rem",
                                  color: config.itemsList.textPrice2,
                                }}>
                                  UND:{item.SalUnitMsr || ''}
                                </p>
                            </div>:''
                            }
                          {role === ROLES.PUBLIC ?
                            <div className="overflow-auto">
                              <p
                                className="text-left"
                                style={{
                                  padding: 1,
                                  fontSize: 12,
                                  fontWeight: "normal",
                                  color: "#808080",
                                }}>
                                {item.ItemCode || ''}
                              </p>
                            </div>
                          : <>
                            <p
                              className="card-subtitle font-weight-bold text-left"
                              style={{
                                fontSize: 25,
                                margin: 1,
                                color: config.itemsList.textPrice2,
                              }}
                            >
                              {item.U_web != 1 ? (
                                <span
                                  style={{
                                    color: config.navBar.iconColor,
                                    fontSize: 20,
                                  }}
                                >
                                  Solicite su cotización
                                </span>
                              ) : (
                                <div>
                                <span className="precioCard">
                                  <div className=" precios">
                                    <div
                                      className="pricePromo col-md-auto"
                                      style={{
                                        padding: 0,
                                        color: "black",
                                        fontSize: "1rem",
                                        width: "200px",
                                      }}
                                    >
                                      <CurrencyFormat
                                        value={Number(
                                          // item.Price
                                          item.PrecioFinal
                                        )}
                                        displayType={"text"}
                                        thousandSeparator={"."}
                                        decimalSeparator={false}
                                        fixedDecimalScale={true}
                                        decimalScale={0}
                                        // prefix={currency.MainCurncy !== item.Currency  ? '' : currency.DocCurrCod}
                                        prefix={"$ "}
                                        suffix={""}
                                      ></CurrencyFormat>
                                      <span> + IVA</span>
                                    </div>
                                  </div>
                                  
                                </span>
                                <div className="overflow-auto">
                                  <p 
                                  className="text-left"
                                  style={{                               
                                    padding: 1,
                                    fontSize: 12,
                                    fontWeight: "normal",
                                    color: "#808080",
                                  }}>
                                    {item.ItemCode || ''}
                                  </p>
                                </div>
                               </div> 
                              )}
                            </p>
                          </>}
                          </div>
                        </div>

                        <div className="card-footer" style={{padding: 0, border: 'none'}}>
                              {role === ROLES.PUBLIC ?
                                <div className="col-12 d-flex justify-content-center">
                                  <button className="btn font-weight-bold" onClick={() => { }} style={{ cursor: 'default', background: 'black', color: 'white' }}>SOLICITE UNA COTIZACIÓN</button>
                                </div>
                              :
                              <>
                                {
                                    item.U_web === 0 || item.U_web === null ?
                                    <div className="ItemName" style={{color:"#AFAFAF", fontSize: 13, margin: 0}}>
                                        <p style={{marginLeft: "14px"}}>LLámenos o envié un correo para cotización</p>
                                    </div>
                                    :
                                    <div style={{width:"100%", display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                                        <div style={item.SalUnitMsr === "KG"?{width:  "8rem", marginRight: card === true && 12 }:{width:  "5rem", marginRight: card === true && 0 }}>
                                            {item.Unidades === "Unidades" ?
                                                <input
                                                disabled={!(!!item.OnHandPrincipal)}
                                                id={'input-quantity-' + item.ItemCode + index}
                                                type="number"
                                                min="1"
                                                value={item.quantity ? Number(item.quantity).toFixed(0) : ''}
                                                className="form-control"
                                                name={'quantity' + item.ItemCode}
                                                placeholder="1"
                                                style={{textAlign: "left", background: '#FFFFFF', marginTop: 1, height: 44.5, borderRadius:"0.7rem"}}
                                                onChange={(event) => {this.changLocalQuantity(index, item, event, item.SalUnitMsr)}}
                                                //onKeyDown={event => event.keyCode == 13 && this.addShoppingCart(item, 'input-quantity-' + item.ItemCode + index)}
                                            />
                                            :item.SalUnitMsr === "KG"?
                                                <div class="input-group">
                                                    <input
                                                        disabled={!(!!item.OnHandPrincipal)}
                                                        id={'input-quantity-' + item.ItemCode + index}
                                                        type="number"
                                                        min={(item.SalPackUn || 1)}
                                                        step={(item.SalPackUn || 1)}
                                                        value={Number(item.quantity <= item.SalPackUn ?item.SalPackUn: item.quantity)}
                                                        className="form-control"
                                                        name={'quantity' + item.ItemCode}
                                                        // placeholder={(item.SalPackUn || 1)}
                                                        style={{textAlign: "left", background: '#FFFFFF', marginTop: 1, height: 44.5, width: "75px",borderTopLeftRadius:"0.7rem", borderBottomLeftRadius:"0.7rem"}}
                                                        onChange={(event) => {this.changLocalQuantity(index, item, event, item.SalUnitMsr)}}
                                                        onKeyDown={(event) => event.preventDefault()}
                                                        //onKeyDown={event => event.keyCode == 13 && this.addShoppingCart(item, 'input-quantity-' + item.ItemCode + index)}
                                                    />
                                                    <div class="input-group-append">
                                                        <span class="input-group-text" id="basic-addon1" style={(item.OnHandPrincipal - item.IsCommited) <= 0 ?{background: "#e27753", border: "transparent", color: "black", fontWeight: "bold", borderTopRightRadius:"0.7rem", borderBottomRightRadius:"0.7rem"}: {background: "#232323", border: "transparent", color: "white", fontWeight: "bold", borderTopRightRadius:"0.7rem", borderBottomRightRadius:"0.7rem"}}>{item.SalUnitMsr}</span>
                                                    </div>
                                                </div>
                                                :
                                                <input
                                                    disabled={!(!!item.OnHandPrincipal)}
                                                    id={'input-quantity-' + item.ItemCode + index}
                                                    type="number"
                                                    min={(item.SalPackUn || 1)}
                                                    step={(item.SalPackUn || 1)}
                                                    value={Number(item.quantity <= item.SalPackUn ?item.SalPackUn: item.quantity)}
                                                    className="form-control"
                                                    name={'quantity' + item.ItemCode}
                                                    placeholder="1"
                                                    style={{textAlign: "left", background: '#FFFFFF', marginTop: 1, height: 44.5, width: "65px",borderRadius:"0.7rem",  marginLeft:'8px'}}
                                                    onChange={(event) => {this.changLocalQuantity(index, item, event, item.SalUnitMsr)}}
                                                    //onKeyDown={event => event.keyCode == 13 && this.addShoppingCart(item, 'input-quantity-' + item.ItemCode + index)}
                                                />
                                            }
                                        </div>
                                        <div className="botonAgregar">
                                            <button 
                                                style={{textAlign: "center", margin: 0}} 
                                                type="button" 
                                                readOnly = {(item.OnHandPrincipal - item.IsCommited) <= 0 ? true : false} 
                                                className= {(item.OnHandPrincipal - item.IsCommited) <= 0 ? "btn btn-block botonAgregarAgotado" : item.flag === 'green' ? "btn btn-block botonAgregar": "btn btn-block botonAgregarAgotado"}  
                                                value={(item.quantity ? Number(item.quantity): '1')} 
                                                onClick={(event)=>{this.changeQuantity(index, item, event)}} 
                                                // onMouseOver={(event)=>{this.mouseOverAddCart(index, item.flag, event)}} 
                                                // onMouseOut={(event)=>{this.mouseOutAddCart(index, item.flag, event)}}
                                            >                                                            
                                            </button>                                                        
                                        </div>
                                        {item.SalUnitMsr !== "KG" &&
                                        <>
                                            {
                                                ((item.U_web !== 0 && item.U_web !== null) && ((item.OnHandPrincipal - item.IsCommited) <= 0 || item.OnHandPrincipal == '')) && 
                                                <div className={"icoCarrito"} style={{fontSize: 33}}>
                                                    {/* <img ref={iconMouse => this.iconMouse[index] = iconMouse} src={config.shoppingCartIcons.carritoAgotado} style={{display: "block", color: "red", cursor: "pointer"}}/> */}
                                                    {/* <i ref={iconMouseOver => this.iconMouseOver[index] = iconMouseOver} className={'fas fa-ban ml-md-2'} style={{display: "none", color: "red", cursor: "pointer"}}/> */}
                                                    {/* <img  ref={iconMouseOver => this.iconMouseOver[index] = iconMouseOver} src={config.shoppingCartIcons.camionAgotado} style={{display: "none", color: "red", cursor: "pointer"}}/> */}
                                                    <i class="fa fa-shopping-cart m-3 " aria-hidden="true" style={{ fontSize: "25px", color: "#e27753" }}></i>
                                                </div>
                                            }
                                            {
                                                ((item.U_web !== 0 && item.U_web !== null) && (item.OnHandPrincipal - item.IsCommited) > 0 && (item.flag === 'green' || item.flag === 'yellow')) &&
                                                <div className={"icoCarrito"} style={{fontSize: 33}}>
                                                    {/* <img ref={iconMouse => this.iconMouse[index] = iconMouse}  src={item.flag === 'green' ? config.shoppingCartIcons.carritoVerde : config.shoppingCartIcons.carritoAmarillo} style={{display: "block", cursor: "pointer"}}/> */}
                                                    {/* <img ref={iconMouseOver => this.iconMouseOver[index] = iconMouseOver}  src={item.flag === 'green' ? config.shoppingCartIcons.camionVerde : config.shoppingCartIcons.camionAmarillo} style={{display: "none",cursor: "pointer"}}/> */}
                                                    <i class="fa fa-shopping-cart m-3" aria-hidden="true" style={{ fontSize: "25px", color: "#232323" }} ></i>
                                                </div>
                                            }
                                        </>
                                        }
                                        {
                                            /* {item.U_web === 1 &&
                                                <div className="col-3" style={{color: "red", fontSize: 33,padding:0, textAlign: "right"}}>
                                                    {item.quantity && <i className={config.icons.trash} style={{cursor: "pointer"}} onClick={() =>  deleteShoppingCart({item, deleteAll: false})}/>}
                                                </div>
                                            } */
                                        }
                                    </div>
                                }
                              </>}
                            </div>

                        <div
                          className="cotizacion row text-center"
                          style={{ margin: 0, padding: 0 }}
                        >
                          {item.U_web === 0 || item.U_web === null
                            ? item.wishlist === 1 && (
                                <div className="col-12" style={{ padding: 0 }}>
                                  <label
                                    style={{
                                      textAlign: "center",
                                      fontSize: 16,
                                    }}
                                  >
                                    para cotización
                                  </label>
                                </div>
                              )
                            : item.wishlist === 1 && (
                                <div className="col-10">
                                  <label
                                    style={{
                                      textAlign: "center",
                                      marginTop: 12,
                                      fontSize: 14,
                                    }}
                                  >
                                    Lista de deseos
                                  </label>
                                </div>
                              )}
                          {item.U_web === 1 && item.wishlist === 1 && (
                            <div
                              className="col-2"
                              style={{
                                color: config.navBar.backgroundColor,
                                fontSize: 20,
                                padding: 0,
                              }}
                            >
                              {item.backOrder ? (
                                <i
                                  className={config.icons.backOrderFalse}
                                  style={{
                                    cursor: "pointer",
                                    marginLeft: 7,
                                    marginTop: 15,
                                  }}
                                  onClick={() => changeBackOrder(item, false)}
                                />
                              ) : (
                                <i
                                  className={config.icons.backOrderTrue}
                                  style={{
                                    cursor: "pointer",
                                    marginLeft: 7,
                                    marginTop: 15,
                                  }}
                                  onClick={() => changeBackOrder(item, true)}
                                />
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
        </div>
        <div className="row">
          <Pagination refresh={this.searchPage} totalRowsRefresh={TotalPage} />
        </div>
        <div class="row">
          {/* <div className="col-sm">
                    </div>
                    <div className="row justify-content-center col-sm">
                        <Paginations totalRecords={TotalPage} pageLimit={10} pageNeighbours={1} onPageChanged={this.onPageChanged}/>
                    </div>
                    <div className="row justify-content-right col-sm">
                        { currentPage && (
                            <span className="current-page d-inline-block h-100 pl-4 text-secondary">
                            Página <span className="font-weight-bold">{ currentPage }</span> / <span className="font-weight-bold">{  Math.ceil(TotalPage/10)}</span>
                            </span>
                        ) }
                    </div> */}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    notificationReducer: store.NotificationReducer,
    shoppingCartReducer: store.ShoppingCartReducer,
    itemsReducer: store.ItemsReducer,
    configReducer: store.ConfigReducer,
    sessionReducer: store.SessionReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setShoppingCart: (value) =>
      dispatch({ type: DISPATCH_ID.SHOPPING_CART_SAVE_CART, value }),
    setItemsFilterSearch: (value) =>
      dispatch({ type: DISPATCH_ID.ITEMS_SAVE_ITEMS_FILTER, value }),
    setNextPage: (value) =>
      dispatch({ type: DISPATCH_ID.ITEMS_SET_NEXTPAGE, value }),
    searchByDashOption: (value) =>
      dispatch({ type: DISPATCH_ID.ITEMS_SET_SEARCH_BY_DASH_OPTION, value }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ItemsList);